import { Component, Inject, OnInit } from '@angular/core';
import { SafetyGeneraldashboardService } from '../../services/safety-generaldashboard.service';
import { EditWorkAreaDepartmentDialogComponent } from '../edit-work-area-department-dialog/edit-work-area-department-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-contractors-involved-dialog',
  templateUrl: './contractors-involved-dialog.component.html',
  styleUrls: ['./contractors-involved-dialog.component.css']
})
export class ContractorsInvolvedDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<EditWorkAreaDepartmentDialogComponent>,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


    CompanyName;
    StaffName;
  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close(false)
  }
saveContractors()
{
  console.log("before Inspection ID", this.data.Id )
  console.log("before Company Name", this.CompanyName )
  console.log("before staff", this.StaffName )
  this._safetyGeneraldashboardService.SaveContractorsInvolved(this.data.Id, this.CompanyName, this.StaffName).subscribe(res =>{
console.log("after",res)
  })
  this.DialogClose()
}

}
